/* Bedding Premium — product-form.js: variants, add to basket, gallery, delivery, sticky bar */
(function () {
  'use strict';
  var theme = window.theme || {};
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function define(n, c) { if (!customElements.get(n)) customElements.define(n, c); }
  function money(c) { return theme.formatMoney ? theme.formatMoney(c) : (c / 100).toFixed(2); }

  /* ---------- Product info (variant logic + form) ---------- */
  define('product-info', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      try { this.variants = JSON.parse($('[data-variants]', this).textContent); } catch (e) { this.variants = []; }
      this.form = document.getElementById(this.getAttribute('data-form-id'));
      this.idInput = this.form ? $('[data-variant-input]', this.form) : null;
      var self = this;
      this.addEventListener('change', function (e) { if (e.target.matches('[data-option-value]')) self.onOptionChange(); });
      if (this.form) this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
      // Remember which submit button was used (also covers the sticky bar, which sits outside the form)
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('button[type="submit"]');
        if (b && self.form && b.form === self.form) self._submitter = b;
      }, true);
      var addQty = $('[data-add-quantity]', this);
      if (addQty) addQty.addEventListener('click', function () { self.addQuantity(Number(addQty.getAttribute('data-add-quantity')), addQty); });
      this.markAvailability();
      this.updateStock(this.currentVariant());
      this.rememberViewed();
    }
    selectedOptions() {
      return $$('.variants__group', this).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
    }
    currentVariant() {
      var id = this.idInput ? Number(this.idInput.value) : null;
      return this.variants.find(function (v) { return v.id === id; }) || this.variants[0];
    }
    onOptionChange() {
      var opts = this.selectedOptions();
      var variant = this.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      $$('.variants__group', this).forEach(function (g) {
        var c = $('input:checked', g), label = $('[data-selected-label]', g);
        if (c && label) label.textContent = c.value;
      });
      this.markAvailability();
      this.update(variant);
    }
    markAvailability() {
      var opts = this.selectedOptions(), variants = this.variants;
      $$('.variants__group', this).forEach(function (group, idx) {
        $$('input[data-option-value]', group).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return test[i] === null || o === test[i]; }); });
          input.classList.toggle('is-unavailable', !ok);
          var label = input.nextElementSibling;
          if (label) label.setAttribute('title', ok ? input.value : input.value + ' – ' + (theme.strings.soldOut || 'Sold out'));
        });
      });
    }
    update(variant) {
      var button = this.form ? $('[data-add-button]', this.form) : null;
      var addText = button ? $('[data-add-text]', button) : null;
      var sticky = document.querySelector('sticky-atc[data-form-id="' + this.getAttribute('data-form-id') + '"]');
      if (!variant) {
        if (button) button.disabled = true;
        if (addText) addText.textContent = theme.strings.unavailable || 'Unavailable';
        if (sticky) sticky.setState(null);
        return;
      }
      if (this.idInput) { this.idInput.value = variant.id; this.idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (button) button.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? (addText.getAttribute('data-label') || theme.strings.addToCart || 'Add to basket') : (theme.strings.soldOut || 'Sold out');
      if (this.form) $$('[data-buy-now]', this.form).forEach(function (b) { b.disabled = !variant.available; });
      // Price
      var wrap = $('[data-price-wrapper]', this);
      if (wrap) {
        var onSale = variant.compare_at_price > variant.price;
        wrap.classList.toggle('price--sale', onSale);
        var p = $('[data-price]', wrap); if (p) p.textContent = money(variant.price);
        var from = $('.price__from', wrap); if (from) from.remove();
        var cmp = $('[data-compare-price]', wrap);
        if (cmp) { cmp.hidden = !onSale; cmp.innerHTML = onSale ? '<span class="visually-hidden">Regular price</span>' + money(variant.compare_at_price) : ''; }
        var save = $('[data-save]', wrap);
        if (save) { save.hidden = !onSale; save.textContent = onSale ? 'Save ' + money(variant.compare_at_price - variant.price) : ''; }
      }
      var inst = $('[data-instalments]', this);
      if (inst) inst.textContent = inst.getAttribute('data-template').replace('[amount]', money(Math.floor(variant.price / 3)));
      var sku = $('[data-sku]', this); if (sku) sku.textContent = variant.sku || '';
      this.updateStock(variant);
      // Media
      if (variant.featured_media) {
        var gallery = $('media-gallery', this);
        if (gallery && gallery.show) gallery.show(variant.featured_media);
      }
      // URL
      if (this.getAttribute('data-update-url') === 'true') {
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
      if (sticky) sticky.setState(variant);
    }
    updateStock(variant) {
      var el = $('[data-stock]', this);
      if (!el || !variant) return;
      var text = $('[data-stock-text]', el);
      var threshold = Number(el.getAttribute('data-threshold')) || 10;
      el.classList.remove('is-low', 'is-out');
      if (!variant.available) { el.classList.add('is-out'); text.textContent = el.getAttribute('data-out'); return; }
      var tracked = variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue';
      if (tracked && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold) {
        el.classList.add('is-low'); text.textContent = el.getAttribute('data-low').replace('[count]', variant.inventory_quantity);
      } else text.textContent = el.getAttribute('data-in');
    }
    buildItems(quantity) {
      var variant = this.currentVariant();
      var qtyInput = document.querySelector('input[name="quantity"][form="' + this.form.id + '"]') || $('input[name="quantity"]', this.form);
      var items = [{ id: variant.id, quantity: quantity || Number(qtyInput ? qtyInput.value : 1) || 1 }];
      var wrap = $('[data-product-gift-wrap]', this.form);
      if (wrap && wrap.checked) items.push({ id: Number(wrap.getAttribute('data-product-gift-wrap')), quantity: 1 });
      return items;
    }
    onSubmit(e) {
      var submitter = e.submitter || this._submitter;
      this._submitter = null;
      if (submitter && submitter.hasAttribute('data-buy-now')) { this.buyNow(e, submitter); return; }
      if (!theme.Cart) return;
      e.preventDefault();
      var button = $('[data-add-button]', this.form);
      var err = $('[data-form-error]', this.form); if (err) err.hidden = true;
      if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
      var self = this;
      var inModal = this.closest('dialog');
      theme.Cart.add(this.buildItems()).then(function () {
        if (inModal) inModal.close();
      }).catch(function (error) { theme.showCartError(error, self.form); })
        .finally(function () { if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); } });
    }
    buyNow(e, btn) {
      // Without the theme cart script the native form posts to /cart/add with return_to=/checkout
      if (!theme.Cart) return;
      e.preventDefault();
      var err = $('[data-form-error]', this.form); if (err) err.hidden = true;
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
      var self = this;
      theme.Cart.add(this.buildItems(), { open: false }).then(function () {
        window.location.href = (theme.routes.root || '/').replace(/\/$/, '') + '/checkout';
      }).catch(function (error) {
        theme.showCartError(error, self.form);
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      });
    }
    addQuantity(qty, btn) {
      if (!theme.Cart) return;
      btn.classList.add('is-loading');
      var self = this;
      theme.Cart.add(this.buildItems(qty)).catch(function (e) { theme.showCartError(e, self.form); })
        .finally(function () { btn.classList.remove('is-loading'); });
    }
    rememberViewed() {
      var handle = this.getAttribute('data-handle');
      if (!handle || this.closest('dialog')) return;
      try {
        var list = JSON.parse(localStorage.getItem('bp-recent')) || [];
        list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
        localStorage.setItem('bp-recent', JSON.stringify(list));
      } catch (e) {}
    }
  });

  /* ---------- Media gallery ---------- */
  define('media-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-gallery-track]', this);
      this.items = $$('.gallery__item', this);
      this.thumbs = $$('[data-thumb]', this);
      this.dots = $$('.gallery__dot', this);
      var self = this;
      this.thumbs.forEach(function (t) { t.addEventListener('click', function () { self.show(Number(t.getAttribute('data-thumb')), true); }); });
      if (this.track) this.track.addEventListener('scroll', function () {
        if (window.innerWidth >= 990) return;
        var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
        self.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
      if (this.getAttribute('data-zoom') === 'true' && window.matchMedia('(hover: hover)').matches) {
        this.items.forEach(function (item) {
          item.addEventListener('mousemove', function (e) {
            if (window.innerWidth < 990) return;
            var r = item.getBoundingClientRect();
            item.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
            item.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
            item.classList.add('is-zooming');
          });
          item.addEventListener('mouseleave', function () { item.classList.remove('is-zooming'); });
        });
      }
      this.initLightbox();
    }
    show(mediaId, userAction) {
      var target = this.items.find(function (i) { return Number(i.getAttribute('data-media-id')) === Number(mediaId); });
      if (!target) return;
      this.items.forEach(function (i) { i.classList.toggle('is-active', i === target); });
      this.thumbs.forEach(function (t) {
        var on = Number(t.getAttribute('data-thumb')) === Number(mediaId);
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var idx = this.items.indexOf(target);
      if (window.innerWidth < 990 && this.track) this.track.scrollTo({ left: idx * this.track.clientWidth, behavior: 'smooth' });
      var gallery = this.getAttribute('class') || '';
      if (window.innerWidth >= 990 && (gallery.indexOf('grid') > -1 || gallery.indexOf('stacked') > -1)) target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    }
    initLightbox() {
      if (this.getAttribute('data-lightbox') !== 'true') return;
      var box = document.getElementById(this.getAttribute('data-lightbox-id'));
      if (!box || typeof box.showModal !== 'function') return;
      var imgs = $$('[data-lightbox-src]', box), current = 0;
      function open(i) {
        var list = imgs.map(function (im) { return Number(im.getAttribute('data-index')); });
        current = Math.max(0, list.indexOf(Number(i)));
        render(); box.showModal(); document.body.classList.add('is-locked');
      }
      function render() {
        imgs.forEach(function (im, k) {
          if (k === current && !im.src) im.src = im.getAttribute('data-lightbox-src');
          im.hidden = k !== current;
        });
      }
      function go(d) { current = (current + d + imgs.length) % imgs.length; render(); }
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-open-lightbox]');
        if (b) open(b.getAttribute('data-open-lightbox'));
      });
      $('[data-lightbox-close]', box).addEventListener('click', function () { box.close(); });
      $('[data-lightbox-prev]', box).addEventListener('click', function () { go(-1); });
      $('[data-lightbox-next]', box).addEventListener('click', function () { go(1); });
      box.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(-1); if (e.key === 'ArrowRight') go(1); });
      box.addEventListener('close', function () { document.body.classList.remove('is-locked'); });
      var sx = null;
      box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); sx = null; });
      if (imgs.length < 2) { $('[data-lightbox-prev]', box).hidden = true; $('[data-lightbox-next]', box).hidden = true; }
    }
  });

  /* ---------- Delivery estimate (UK working days) ---------- */
  define('delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.cutoff = Number(this.getAttribute('data-cutoff')) || 14;
      this.mode = this.getAttribute('data-days') || 'weekdays';
      this.transit = Number(this.getAttribute('data-transit')) || 1;
      this.holidays = (this.getAttribute('data-holidays') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      this.template = this.getAttribute('data-template') || '';
      this.text = $('[data-delivery-text]', this);
      var self = this;
      this.render(); this.timer = setInterval(function () { self.render(); }, 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    ukNow() {
      // Build a Date whose fields represent the current wall-clock time in London
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var get = function (t) { return Number(parts.find(function (p) { return p.type === t; }).value); };
      return new Date(get('year'), get('month') - 1, get('day'), get('hour') % 24, get('minute'));
    }
    iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
    isDispatchDay(d) {
      var day = d.getDay();
      if (this.holidays.indexOf(this.iso(d)) > -1) return false;
      if (this.mode === 'all') return true;
      if (this.mode === 'mon-sat') return day !== 0;
      return day !== 0 && day !== 6;
    }
    isDeliveryDay(d) { return d.getDay() !== 0 && this.holidays.indexOf(this.iso(d)) === -1; }
    render() {
      if (!this.text || !this.template) return;
      var now = this.ukNow();
      var dispatch = new Date(now);
      var cut = new Date(now); cut.setHours(this.cutoff, 0, 0, 0);
      if (!this.isDispatchDay(dispatch) || now >= cut) {
        dispatch.setDate(dispatch.getDate() + 1);
        while (!this.isDispatchDay(dispatch)) dispatch.setDate(dispatch.getDate() + 1);
        dispatch.setHours(this.cutoff, 0, 0, 0);
      } else dispatch = cut;
      var deliver = new Date(dispatch), n = 0;
      while (n < this.transit) { deliver.setDate(deliver.getDate() + 1); if (this.isDeliveryDay(deliver) && deliver.getDay() !== 6) n++; }
      var ms = dispatch - now, h = Math.floor(ms / 36e5), m = Math.floor(ms / 6e4) % 60;
      var time = h >= 24 ? Math.floor(h / 24) + 'd ' + (h % 24) + 'h' : h + 'h ' + m + 'm';
      var date = deliver.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
      this.text.innerHTML = this.template.replace('[time]', '<strong>' + time + '</strong>').replace('[date]', '<strong>' + date + '</strong>');
    }
  });

  /* ---------- Sticky add to basket ---------- */
  define('sticky-atc', class extends HTMLElement {
    connectedCallback() {
      var form = document.getElementById(this.getAttribute('data-form-id'));
      var trigger = form ? $('[data-add-button]', form) : null;
      if (!trigger || !('IntersectionObserver' in window)) return;
      this.hidden = false;
      var self = this, footer = document.querySelector('.footer');
      var buttonVisible = true, footerVisible = false;
      function toggle() {
        var show = !buttonVisible && !footerVisible && trigger.getBoundingClientRect().top < 0;
        self.classList.toggle('is-visible', show);
        self.setAttribute('aria-hidden', String(!show));
        $$('button, a', self).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
        document.body.classList.toggle('has-sticky-atc', show);
      }
      new IntersectionObserver(function (en) { buttonVisible = en[0].isIntersecting; toggle(); }).observe(trigger);
      if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; toggle(); }).observe(footer);
      toggle();
    }
    setState(variant) {
      var btn = $('[data-sticky-button]', this), price = $('[data-sticky-price]', this), title = $('[data-sticky-variant]', this);
      if (!variant) { btn.disabled = true; btn.textContent = theme.strings.unavailable || 'Unavailable'; return; }
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? (btn.getAttribute('data-label') || theme.strings.addToCart || 'Add to basket') : (theme.strings.soldOut || 'Sold out');
      if (price) price.textContent = money(variant.price);
      if (title && variant.title !== 'Default Title') title.textContent = variant.title;
    }
  });
})();
